/* =========================================
   KYRA PRODUCT CUSTOM - EVENT DELEGATION
========================================= */

document.addEventListener("click", function (e) {
  const button = e.target.closest(".pc-variant-btn");
  if (!button) return;

  const scope = button.closest(".pc-container") || document;

  const variantId = button.dataset.variantId;
  const variantPrice = parseInt(button.dataset.variantPrice, 10);
  const variantCompare = parseInt(button.dataset.variantCompare, 10);
  const variantTitle = button.dataset.variantTitle;

  const galleries = scope.querySelectorAll(".pc-variant-gallery");
  const variantButtons = scope.querySelectorAll(".pc-variant-btn");

  /* ATTIVA BOTTONE */
  variantButtons.forEach((btn) => btn.classList.remove("active"));
  button.classList.add("active");

  /* CAMBIA GALLERY */
  galleries.forEach((gallery) => {
    gallery.classList.toggle("active", gallery.dataset.variantId === variantId);
  });

  /* AGGIORNA INPUT */
  const variantInput = scope.querySelector("#pc-variant-input");

  if (variantInput && variantId) {
    variantInput.value = variantId;

    history.replaceState(
      {},
      "",
      window.location.pathname + "?variant=" + variantId
    );
  }

  /* AGGIORNA NOME COLORE */
  const colorName = scope.querySelector(".pc-color-name");

  if (colorName && variantTitle) {
    colorName.textContent = variantTitle;
  }

  /* AGGIORNA PREZZO */
  const priceEl = scope.querySelector("#ProductPrice");
  const compareEl = scope.querySelector("#ComparePrice");

  if (priceEl && !Number.isNaN(variantPrice)) {
    priceEl.textContent = new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR"
    }).format(variantPrice / 100);
  }

  if (compareEl) {
    if (
      !Number.isNaN(variantCompare) &&
      !Number.isNaN(variantPrice) &&
      variantCompare > variantPrice
    ) {
      compareEl.textContent = new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR"
      }).format(variantCompare / 100);

      compareEl.style.display = "inline";
    } else {
      compareEl.textContent = "";
      compareEl.style.display = "none";
    }
  }

  /* KLARNA INSTALLMENT UPDATE */
  const klarnaBox = scope.querySelector("#KlarnaInstallment");

  if (klarnaBox && !Number.isNaN(variantPrice)) {
    const installment = variantPrice / 3;

    klarnaBox.textContent = new Intl.NumberFormat("it-IT", {
      style: "currency",
      currency: "EUR"
    }).format(installment / 100);
  }

  /* SCROLL SOLO SU PAGINA PRODOTTO */
  const isQuickView = button.closest("#KyraQuickView");

  if (!isQuickView) {
    setTimeout(() => {
      const activeGallery = scope.querySelector(".pc-variant-gallery.active");
      if (!activeGallery) return;

      const rect = activeGallery.getBoundingClientRect();
      const y = rect.top + window.pageYOffset;

      window.scrollTo({
        top: y - 140,
        behavior: "smooth"
      });
    }, 100);
  }
});



/* =========================================
   COLORE RULLO
========================================= */

document.addEventListener('DOMContentLoaded', function () {
  const cylinder = document.querySelector('[data-color-cylinder]');
  if (!cylinder) return;

  const next = cylinder.querySelector('[data-color-next]');
  const currentName = cylinder.querySelector('[data-color-current]');
  const variantInput = document.getElementById('pc-variant-input');
  const options = Array.from(cylinder.querySelectorAll('[data-color-option]'));

  let index = Math.max(
    0,
    options.findIndex(option => option.dataset.active === 'true')
  );

  function selectColor(newIndex) {
    if (!options.length) return;

    index = (newIndex + options.length) % options.length;

    const option = options[index];
    const variantId = option.dataset.variantId;

    currentName.classList.add('is-changing');

    setTimeout(function () {
      currentName.textContent = option.dataset.variantTitle;
      currentName.classList.remove('is-changing');

      if (variantInput) {
        variantInput.value = variantId;
      }

      const matchingThumb = document.querySelector(
        '.pc-variant-btn[data-variant-id="' + variantId + '"]'
      );

      if (matchingThumb) {
        matchingThumb.click();

        matchingThumb.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }, 180);
  }

  next.addEventListener('click', function () {
    selectColor(index + 1);
  });
});



/* =========================================
   PRODUCT ACCORDION — UNA SEZIONE APERTA
========================================= */

document.addEventListener("toggle", function (e) {
  const currentDetails = e.target.closest(".pc-accordion");
  if (!currentDetails || !currentDetails.open) return;

  const scope = currentDetails.closest(".pc-container") || document;

  scope.querySelectorAll(".pc-accordion[open]").forEach((details) => {
    if (details !== currentDetails) {
      details.removeAttribute("open");
    }
  });
}, true);